import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import DashboardShell from "@/components/layout/DashboardShell";
import { useT } from "@/lib/i18n";
import ExportButton from "@/components/ExportButton";
import HelpVideoButton from "@/components/HelpVideoButton";

export default function SubscriberReports() {
  const { t } = useT();
  const [daily, setDaily] = useState([]);
  const [helpers, setHelpers] = useState([]);

  useEffect(() => {
    api.get("/subscriber/reports/daily").then((r) => setDaily(r.data));
    api.get("/subscriber/reports/helper-collection").then((r) => setHelpers(r.data));
  }, []);

  const maxAmt = Math.max(1, ...daily.map((d) => d.amount));
  const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

  return (
    <DashboardShell
      title={t("nav.reports")}
      action={
        <div className="flex gap-2">
          <HelpVideoButton screen="reports" />
          <ExportButton basePath="/subscriber/export/daily-report" baseFilename="daily_report" label={t("sub.exportDaily")} testId="export-daily-btn" size="sm" />
          <ExportButton basePath="/subscriber/export/helper-collection" baseFilename="helper_collection" label={t("sub.exportHelper")} testId="export-helper-btn" size="sm" />
        </div>
      }
    >
      <div className="am-card p-6">
        <h2 className="font-display text-xl font-bold mb-4">{t("sub.dailyChartTitle")}</h2>
        <div className="grid grid-cols-7 gap-3 items-end h-56">
          {daily.map((d) => {
            const h = (d.amount / maxAmt) * 100;
            return (
              <div key={d.date} className="flex flex-col items-center gap-2">
                <div className="flex-1 w-full flex items-end">
                  <div className="w-full rounded-t-2xl bg-primary transition-all duration-700" style={{ height: `${Math.max(6, h)}%` }} title={inr(d.amount)} />
                </div>
                <div className="text-xs font-mono">{d.date.slice(5)}</div>
                <div className="text-xs font-semibold">{inr(d.amount)}</div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="am-card p-2 mt-6 overflow-x-auto">
        <div className="flex items-center justify-between p-4 pb-2">
          <h2 className="font-display text-xl font-bold">{t("sub.helperWise")}</h2>
          <ExportButton basePath="/subscriber/export/cash" baseFilename="cash_collection" label={t("sub.exportAll")} testId="export-cash-btn" size="sm" />
        </div>
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs uppercase tracking-widest text-muted-foreground border-b">
              <th className="px-4 py-3">{t("nav.helpers")}</th>
              <th className="px-4 py-3">{t("sub.receipts")}</th>
              <th className="px-4 py-3">{t("sub.collected")}</th>
            </tr>
          </thead>
          <tbody>
            {helpers.map((h) => (
              <tr key={h.helper_id} className="border-b last:border-0">
                <td className="px-4 py-3 font-semibold">{h.name}</td>
                <td className="px-4 py-3 font-mono">{h.receipts}</td>
                <td className="px-4 py-3 font-mono font-bold">{inr(h.amount)}</td>
              </tr>
            ))}
            {helpers.length === 0 && <tr><td colSpan={3} className="py-12 text-center text-muted-foreground">{t("sub.noData")}</td></tr>}
          </tbody>
        </table>
      </div>
    </DashboardShell>
  );
}
